// import  { Storage } from "aws-amplify";
// import config from "../config.json";

// export default class S3Service {

   
//     static classInstance: S3Service;
//     static getInstance() {
//         if (!S3Service.classInstance) {
//             S3Service.classInstance = new S3Service();
//         }
//         return this.classInstance;
//     }

//     constructor() {
//         Storage.configure(config.Storage);
//     }

//     async writeFile(filePath: string, fileContent: any) {
//         return await Storage.put(filePath, fileContent);
//     }

//     async listFiles(filePath: string) {
//         return await Storage.list("", { customPrefix: { public: filePath } });
//     }

//     async writeFileInFolder(filePath: string, fileContent: any, folder: string,contentType?:string) {

//         return await Storage.put(filePath, fileContent, { customPrefix: { public: `${folder}/`},contentType:contentType });
//     }

//     async readFile(filePath: string, folder: string) {
//         return await Storage.get(filePath, { customPrefix: { public: `${folder}/` } });
//     }

//     async removeFile(file: string, folder: string) {
//         await Storage.remove(file, { customPrefix: { public: `${folder}/` } });
//     }

//     convertToFile(url: string | ArrayBuffer | null, imageType: string, fileName: string) {
//         try {
//             let blob: any = [this.dataURItoBlob(url)]
//             let metadata = {
//                 type: imageType
//             };
//             return new File(blob, fileName, metadata)
//         } catch (err) {
//             console.error(err)
//             return null
//         }
//     }

//     dataURItoBlob(dataURI: any) {
//         try {
//             // convert base64/URLEncoded data component to raw binary data held in a string
//             var byteString;
//             if (dataURI?.split(',')[0].indexOf('base64') >= 0)
//                 byteString = atob(dataURI?.split(',')[1]);
//             else
//                 byteString = unescape(dataURI?.split(',')[1]);

//             // separate out the mime component
//             var mimeString = dataURI?.split(',')[0]?.split(':')[1]?.split(';')[0];

//             // write the bytes of the string to a typed array
//             var ia = new Uint8Array(byteString.length);
//             for (var i = 0; i < byteString.length; i++) {
//                 ia[i] = byteString.charCodeAt(i);
//             }

//             return new Blob([ia], { type: mimeString });
//         } catch (err) {
//             console.error(err)
//             return new Blob();
//         }
//     }
// }


import { uploadData, list, getUrl, remove } from "aws-amplify/storage";
import { generateClient } from "aws-amplify/api";
import config from "../config.json";

export default class S3Service {
  static classInstance: S3Service;

  static getInstance() {
    if (!S3Service.classInstance) {
      S3Service.classInstance = new S3Service();
    }
    return this.classInstance;
  }

  constructor() {
    // configure storage from config if needed
    // (optional if already configured globally via Amplify.configure)
  }

  async writeFile(filePath: string, fileContent: any, contentType?: string) {
    try {
      const result = await uploadData({
        path: filePath,
        data: fileContent,
        options: {
          contentType: contentType,
        },
      }).result;
      console.log("File uploaded successfully:", result);
      return result;
    } catch (err) {
      console.error("Upload error:", err);
      throw err;
    }
  }

  async listFiles(filePath: string) {
    try {
      const result = await list({
        prefix: filePath,
      });
      return result.items;
    } catch (err) {
      console.error("List files error:", err);
      throw err;
    }
  }

  async writeFileInFolder(
    filePath?: string,
    fileContent?: any,
    folder?: string,
    contentType?: string
  ) {
    try {
      const result = await uploadData({
        path: `${folder}/${filePath}`,
        data: fileContent,
        options: {
          contentType: contentType,
        },
      }).result;
      console.log("File uploaded in folder:", result);
      return result;
    } catch (err) {
      console.error("Upload in folder error:", err);
      throw err;
    }
  }

  async readFile(filePath: string, folder: string) {
    try {
      const { url } = await getUrl({
        path: `${folder}/${filePath}`,
      });
      return url;
    } catch (err) {
      console.error("Get file URL error:", err);
      throw err;
    }
  }

  async removeFile(file: string, folder: string) {
    try {
      await remove({
        path: `${folder}/${file}`,
      });
      console.log("File removed");
    } catch (err) {
      console.error("Remove file error:", err);
      throw err;
    }
  }

  convertToFile(
    url: string | ArrayBuffer | null,
    imageType: string,
    fileName: string
  ) {
    try {
      const blob: any = [this.dataURItoBlob(url)];
      const metadata = {
        type: imageType,
      };
      return new File(blob, fileName, metadata);
    } catch (err) {
      console.error("Convert to file error:", err);
      return null;
    }
  }

  dataURItoBlob(dataURI: any) {
    try {
      let byteString;
      if (dataURI?.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI?.split(",")[1]);
      else byteString = unescape(dataURI?.split(",")[1]);

      const mimeString = dataURI?.split(",")[0]?.split(":")[1]?.split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    } catch (err) {
      console.error("Data URI to Blob error:", err);
      return new Blob();
    }
  }
}

